<ion-content no-bounce>
  <div class="login-background"></div>
  <ion-grid no-padding>
    <ion-row justify-content-center no-padding style="justify-content: center">
      <ion-col size-sm="8" size-lg="6" size-xl="4" align-self-center no-padding>
        <div class="login-header" class="ion-text-center">
          <img class="logo" src="assets/pe-pro-logo.png" alt="PE Pro Logo" />
        </div>
        <div class="login-container-wrapper">
          @if (state === 'loading' || state === 'resending') {
            <div class="login-spinner-wrapper">
              <ion-spinner class="primary-spinner"></ion-spinner>
            </div>
          } @else {
            <div class="ion-text-center">
              <ion-icon
                size="large"
                [color]="successful ? 'success' : 'danger'"
                [name]="successful ? 'checkmark-circle-outline' : 'close-circle-outline'"
              ></ion-icon>
              @if (state === 'successful') {
                <h1>Thank you for verifying your email address!</h1>
                <p>You can now proceed to the app.</p>
                <ion-button color="primary" routerLink="/login">Go to Login</ion-button>
                <p>If you've never signed in, then tap the 'Don't know your password' button to get started.</p>
              }
              @if (state === 'already-complete') {
                <h1>This email address is already verified!</h1>
                <p>You can now proceed to the app.</p>
                <ion-button color="primary" routerLink="/login">Go to Login</ion-button>
              }
              @if (state === 'email-resent') {
                <h1>We've sent you a new verification link.</h1>
                <p>Please check your inbox and click the link in the email.</p>
                <p>
                  If you don't receive it, please email us at
                  <a href="mailto:enquiries@peproapp.com">enquiries&#64;peproapp.com</a>.
                </p>
              }
              @if (state === 'error') {
                <h1>Something has gone wrong!</h1>
                <p>
                  Please email us at
                  <a href="mailto:enquiries@peproapp.com">enquiries&#64;peproapp.com</a>.
                </p>
              }
            </div>
          }
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
